import React from 'react';
import Footer from '../layout/Footer/Footer';

const footers = [
    { path: '/login', element: null, exact: true },
    { path: '/register', element: null, exact: true },
    { path: '/forgot-password', element: null, exact: true },
    { path: '/verify', element: null, exact: true },
    { path: '/404', element: null, exact: true },
    { path: '*', element: <Footer /> },
];

export default footers;
